import { render, staticRenderFns } from "./ApplyMarkupsInsurance.vue?vue&type=template&id=0a4eb58e&scoped=true"
import script from "./ApplyMarkupsInsurance.vue?vue&type=script&lang=js"
export * from "./ApplyMarkupsInsurance.vue?vue&type=script&lang=js"
import style0 from "./ApplyMarkupsInsurance.vue?vue&type=style&index=0&id=0a4eb58e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4eb58e",
  null
  
)

export default component.exports